import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { compose, path, prop, when } from 'ramda';
import { isNotNilOrEmpty } from '@@serverHelpers/index.mjs';
import { useProcess } from '@fasstech/oip-starter-utils/app';
import { dateTsToFr } from '@@viewHelpers/date.js';
import useDownloadDocumentsMutation from '@@views/simulationRecap/client/hooks/useDownloadDocumentsMutation';
import useSendMailSimulationRecapMutation from '@@views/simulationRecap/client/hooks/useSendMailSimulationRecapMutation';

// Hook de la synthèse simulation prévoyance collective :
// pas de tarif ni de produit sélectionné, uniquement navigation, édition et documents
const useSimulationRecapGroupProtection = ({ project }) => {
  const { processHandlers, context } = useProcess();
  const { onFormSubmit: downloadMutation } = useDownloadDocumentsMutation();
  const { onFormSubmit: sendEmailMutation } =
    useSendMailSimulationRecapMutation();
  const [documentsDownloaded, setDocumentsDownloaded] = useState(false);
  const [canSendMail, setCanSendMail] = useState(prop('canSendMail', project));

  const form = useForm({
    mode: 'onBlur',
    defaultValues: {
      offer: {
        effectDate: compose(
          when(isNotNilOrEmpty, dateTsToFr),
          path(['offer', 'effectDate'])
        )(project)
      }
    }
  });

  const projectId = context?.projectId;
  const shouldRequireDocumentsDownload = compose(
    isNotNilOrEmpty,
    prop('documentsToDownload')
  )(project);
  const cantGoNext = shouldRequireDocumentsDownload && !documentsDownloaded;

  const onPrevWithAction = (action) => () =>
    processHandlers.onPrev({ context: { projectId, action } });

  const $onClickPrev = () => processHandlers.onPrev({ context: { projectId } });

  const onSubmit = () => {
    if (cantGoNext) return;
    processHandlers.onNext({ context: { projectId } });
  };

  return {
    form,
    onSubmit,
    $onClickPrev,
    onModifyEffectDate: onPrevWithAction('ON_MODIFY_EFFECT_DATE'),
    onEditCompany: onPrevWithAction('ON_EDIT_COMPANY'),
    onEditDemography: onPrevWithAction('ON_EDIT_DEMOGRAPHY'),
    downloadMutation,
    sendEmailMutation,
    setDocumentsDownloaded,
    canSendMail,
    setCanSendMail,
    cantGoNext
  };
};

export default useSimulationRecapGroupProtection;
